export const baseUrl = 'http://localhost:43210/visualtest.html?#/';
